import { render } from "./LittleRedDot.vue?vue&type=template&id=0dcfc58c&ts=true"
import script from "./LittleRedDot.vue?vue&type=script&lang=ts"
export * from "./LittleRedDot.vue?vue&type=script&lang=ts"

import "./LittleRedDot.vue?vue&type=style&index=0&id=0dcfc58c&lang=css"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__